import * as React from 'react';
import { useSelector } from 'react-redux';
import { useEventCallback } from '@cian/react-utils';
import { useDeviceType } from '@cian/ui-kit';

import { OfficeCard } from '../../components/OfficeCard';
import { CollapsedListContainer } from '../CollapsedListContainer';
import { OfficesList } from '../../components/OfficesList';
import { PhoneButtonContainer } from '../PhoneButtonContainer';
import { selectBuilderInfo, selectBuilderOffices } from '../../selectors/builder';
import { trackShowPhoneClick } from './tracking';
import { Section } from '../../components/Section';
import { IOffice } from '../../types/builder';

export const OfficesContainer = () => {
  const deviceType = useDeviceType();
  const builderInfo = useSelector(selectBuilderInfo);
  const offices = useSelector(selectBuilderOffices);

  const collapsedOfficesCount = React.useMemo(() => {
    switch (deviceType) {
      case 'phone':
        return 3;
      case 'tablet':
        return 4;
      case 'desktop':
        return 6;
    }
  }, [deviceType]);

  const handleShowPhone = useEventCallback(() => {
    trackShowPhoneClick(builderInfo.id);
  });

  const renderItem = useEventCallback((office: IOffice, index: number) => {
    return (
      <OfficeCard
        key={index}
        office={office}
        phoneButton={<PhoneButtonContainer text="Показать телефон" onShow={handleShowPhone} buttonType="text" />}
      />
    );
  });

  const renderList = useEventCallback((offices: React.ReactNode) => {
    return <OfficesList>{offices}</OfficesList>;
  });

  if (!offices.length) {
    return null;
  }

  return (
    <Section title="Офисы продаж и демонстрационные площадки" dataName="Offices">
      <CollapsedListContainer
        list={offices}
        collapsedLength={collapsedOfficesCount}
        renderItem={renderItem}
        renderList={renderList}
      />
    </Section>
  );
};
